import moment from "moment";
import { updateSession } from "../../../slices/sessions/updateSession/thunk";
import { terminateSession } from "../../../slices/sessions/terminateSession/thunk";

export const updateSessionApiCall = (
    value, 
    dispatch, 
    setLoading, 
    customerId, 
    setUpdateSession, 
    isView, 
    sessionInfo, 
    terminateSessions, 
    setButtonInitiateSession, 
    sessionAction,
    setShowForm,
    onSuccessCallback = null, // Success callback parameter
    toggle
) => {
    // Check if current pathname includes 'simulate'
    const isSimulatePage = window.location.pathname.includes('simulate');
    
    const baseObj = {
        eventType: sessionAction === "terminate" ? "Ended" : "Updated",
        timestamp: moment(value?.sessionTime).format('YYYY-MM-DDTHH:mm:ss[Z]'),
        sessionId: `TEST-SESSION-${value.sessionId}`,
        subscriptionId: value?.subscriptionId?.value || value?.subscriptionId,
        seqno: value?.sequence,
        uom: value?.uom?.value || value?.uom,
        usageEventType: value?.usageEventType?.value || value?.usageEventType
    };

    if (sessionAction === "terminate") {
        baseObj.usedServiceUnit = parseFloat(value?.usedUnits) || 0;
    } else {
        baseObj.requestedServiceUnit = parseFloat(value?.requestedUnits) || 0;
    }

    if (value?.attributes && Array.isArray(value.attributes)) {
        const validAttributes = value.attributes.filter(attr => 
            attr.name && attr.value && 
            (typeof attr.name === 'string' ? attr.name : attr.name?.value)
        );
        
        if (validAttributes.length > 0) {
            baseObj.attributes = validAttributes.map(attr => {
                const name = typeof attr.name === 'string' ? attr.name : attr.name?.value;
                let attrValue = attr.value;
                const valueType = attr.name?.valueType || attr.valueType;
                // Type conversion based on valueType
                switch (valueType) {
                    case "integer":
                        attrValue = attrValue === "" ? "" : parseInt(attrValue, 10);
                        break;
                    case "float64":
                        attrValue = attrValue === "" ? "" : parseFloat(attrValue);
                        break;
                    case "bool":
                        case "list":
                        case "string":
                    default:
                        // keep as string
                        break;
                }
                return {
                    name,
                    value: attrValue
                };
            });
        }
    }

    const jsonObj = JSON.stringify(baseObj);

    // Create success callback based on current page context
    const handleSuccess = () => {
        if (isSimulatePage && onSuccessCallback) {
            // On simulate page, reset the form
            onSuccessCallback();
        } else if (!isSimulatePage && setShowForm) {
            // On view page, close the form
            setShowForm(false);
        }
        toggle('1');
        onSuccessCallback();
    };

    if (sessionAction === "terminate") {
        dispatch(terminateSession(
            jsonObj, 
            setLoading, 
            customerId, 
            value?.subscriptionId?.value || value?.subscriptionId, 
            setUpdateSession, 
            setButtonInitiateSession,
            handleSuccess // Pass the context-aware success callback
        ));
    } else {
        dispatch(updateSession(
            jsonObj, 
            setLoading, 
            customerId, 
            value?.subscriptionId?.value || value?.subscriptionId, 
            setUpdateSession, 
            setButtonInitiateSession,
            handleSuccess // Pass the context-aware success callback
        ));
    }
};